<template>
  <div class="top-value-div row m-0">
    <div class="col-lg-6 d-flex flex-column flex-wrap">
      <div class="details-soft-text dn-mb" v-if="!view_to_offer && is_sale && ltype == 'sale'">For Sale at (RM {{ addComma(sale_sqft) }} /sqft)</div>
      <div class="details-soft-text dn-mb" v-else-if="!view_to_offer && is_rent && ltype == 'rent'">For Rent at (RM {{ addComma(rent_sqft) }} /sqft/Month)</div>
      <div class="details-soft-text dn-mb" v-else-if="is_auction && ltype == 'auction'">For Auction at (RM {{ addComma(auction_sqft) }} /sqft)</div>
      <div class="details-soft-text dn-mb" v-else-if="min_price">Minimum price at (RM {{ addComma(min_sqft) }} /sqft)</div>

      <div v-if="min_price" class="details-soft-text db-mn text-capitalize font-weight-bold" style="color:var(--p4text1, #FFFFFF);">Minimum Price</div>
      <div v-else class="details-soft-text db-mn text-capitalize font-weight-bold" style="color:var(--p4text1, #FFFFFF);">For {{ ltype }}</div>

      <div v-if="view_to_offer" class="details-price">Open to offer price</div>
      <div v-else-if="is_sale && ltype == 'sale'" class="details-price">RM {{ addComma(sale_price) }}</div>
      <div v-else-if="is_rent && ltype == 'rent'" class="details-price">RM {{ addComma(rent_price) }}</div>
      <div v-else-if="is_auction && ltype == 'auction'" class="details-price">RM {{ addComma(auction_price) }}</div>
      <div v-else-if="min_price" class="details-price">RM {{ addComma(min_price) }}</div>

      <div v-if="view_to_offer"></div>
      <div class="details-soft-text db-mn pt-3" v-else-if="is_sale && ltype == 'sale'">RM {{ addComma(sale_sqft) }} /sqft</div>
      <div class="details-soft-text db-mn pt-3" v-else-if="is_rent && ltype == 'rent'">RM {{ addComma(rent_sqft) }} /sqft/Month</div>
      <div class="details-soft-text db-mn pt-3" v-else-if="is_auction && ltype == 'auction'">RM {{ addComma(auction_sqft) }} /sqft</div>
      <div class="details-soft-text db-mn pt-3" v-else-if="min_price">RM {{ addComma(min_sqft) }} /sqft</div>

      <div class="details-soft-text mt-1 mb-0" v-if="is_auction && ltype == 'auction' && auction_venue">
        Venue: {{ auction_venue }}
      </div>
      <div class="details-soft-text " v-if="is_auction && ltype == 'auction' && auction_date">
        Auction Date:  {{ auction_date }}
      </div>
    </div>
      
    <div class="col-lg-6 p-0">
      <button v-if="min_price" id="details-calc-popup" data-toggle="modal" data-target="#newlaunch-brochure">
        <div class="w-75 text-truncate text-left">Project Brochures</div>
        <div class="small-red-btn">View</div>
      </button>
      <button v-else-if="!view_to_offer" id="details-calc-popup" data-toggle="modal" data-target="#details-calgroup">
        <div v-if="ltype == 'rent'" class="w-75 text-truncate text-left">Agreement Payable RM {{ addComma(totalAgree) }}</div>
        <div v-else class="w-75 text-truncate text-left">Loan Amount Payable RM {{ addComma(monthPay) }}</div>
        <div class="small-red-btn">View</div>
      </button>
    </div>

    <!-- Floating Brochure -->
    <div v-if="min_price" class="modal fade" id="newlaunch-brochure" tabindex="-1" role="dialog" aria-labelledby="newlaunchBrochure" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content brochure-modal">
          <div class="d-flex align-items-center pb-4">
            <div class="general-heading-1 mr-auto">Project Brochures</div>
            <button data-dismiss="modal" class="popup-back-btn">✕</button>
          </div>
          <ol v-if="brochures">
            <li v-for="(row, index) in brochures" :key="index" class="my-3">
              <a :href="row.name.url" target="_blank" rel="noopener noreferrer" class="border-all rounded p-3 m-3 d-flex flex-column align-items-center justify-content-center">
                <i class="far fa-file-alt" style="font-size: 24px;"></i>
                <span class="mt-3">View</span>
              </a>
            </li>
          </ol>
          <div v-else class="text-center">No Brochure for this project.</div>
        </div>
      </div>
    </div>
    <!-- Floating Calculator -->
    <div v-else class="modal fade" id="details-calgroup" tabindex="-1" role="dialog" aria-labelledby="detailsCalgroup" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div id="calgroup-modal" class="modal-content">
          <div class="calgroup-header stick-top">
            <button data-dismiss="modal" class="popup-back-btn">✕</button>

            <div class="details-soft-text" v-if="view_to_offer"></div>
            <div class="details-soft-text" v-else-if="is_sale && ltype == 'sale'">For Sale at (RM {{ addComma(sale_sqft) }} /sqft)</div>
            <div class="details-soft-text" v-else-if="is_rent && ltype == 'rent'">For Rent at (RM {{ addComma(rent_sqft) }} /sqft/Month)</div>
            <div class="details-soft-text" v-else-if="is_auction && ltype == 'auction'">For Auction at (RM {{ addComma(auction_sqft) }} /sqft)</div>

            <div v-if="view_to_offer" class="details-price">Open to offer price</div>
            <div v-else-if="is_sale && ltype == 'sale'" class="details-price">RM {{ addComma(sale_price) }}</div>
            <div v-else-if="is_rent && ltype == 'rent'" class="details-price">RM {{ addComma(rent_price) }}</div>
            <div v-else-if="is_auction && ltype == 'auction'" class="details-price">RM {{ addComma(auction_price) }}</div>
          </div>
          <cal-group
            mode="m"
            :ltype="ltype" 
            :sale_price="sale_price"
            :rent_price="rent_price"
            :auction_price="auction_price">
          </cal-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "top-value",
    props: ['is_sale', 'sale_price', 'is_rent', 'rent_price', 'is_auction', 'auction_price', 'min_price', 'bsqft', 'lsqft', 'ltype', 'brochures', 'view_to_offer', 'auction_venue', 'auction_date'],
    data() {
      return {
        sale_sqft: '',
        rent_sqft: '',
        auction_sqft: '',
        min_sqft: '',
      };
    },
    mounted() {
      this.getSqft();
    },
    methods: {
      addComma: function (num) {
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      },
      getSqft: function () {
        let vm = this;
        if (vm.bsqft) {
          vm.sale_sqft = (vm.sale_price / vm.bsqft).toFixed(2);
          vm.rent_sqft = (vm.rent_price / vm.bsqft).toFixed(2);
          vm.auction_sqft = (vm.auction_price / vm.bsqft).toFixed(2);
          vm.min_sqft = (vm.min_price / vm.bsqft).toFixed(2);
        } else if (vm.lsqft) {
          vm.sale_sqft = (vm.sale_price / vm.lsqft).toFixed(2);
          vm.rent_sqft = (vm.rent_price / vm.lsqft).toFixed(2);
          vm.auction_sqft = (vm.auction_price / vm.lsqft).toFixed(2);
          vm.min_sqft = (vm.min_price / vm.lsqft).toFixed(2);
        } else {
          vm.sale_sqft = null;
          vm.rent_sqft = null;
          vm.auction_sqft = null;
          vm.min_sqft = null;
        }

      },
      isEven: function (n) {
        var num = n;
        if (Math.floor(n) % 2 == 0) { // is even with decimal
          num = Math.round(n)
          if (num % 2 != 0) {
            num = num + 1
          }
        } else { // is odd with decimal
          num = Math.floor(n) + 1;
        }
        return num;
      },
    },
    computed: {
      totalAgree() { 
        var monthRent = this.rent_price || 0;
        var agreeCharge = 0;
        var tax = Math.ceil(((monthRent * 12)) / 250) * 3;
        if (monthRent <= 10000) {
          agreeCharge = Math.round(monthRent * 0.25);
        } else {
          agreeCharge = Math.round(2500 + (monthRent - 10000) * 0.20);
        }
        if (tax < 0) { tax = 0 }
        var stampDuty = this.isEven(tax);
        return Math.round(agreeCharge + stampDuty + 10) 
      },
      monthPay() {
        if (this.ltype == 'sale' && this.is_sale) {
          var totalPrin = this.sale_price * 90 / 100;
        } else {
          var totalPrin = this.auction_price * 90 / 100;
        }
        let x = 5 / 1200;
        let w = 12 * 30;
        let y = Math.pow((1 + x), w);
        return Math.round((totalPrin * x) * (y) / (y - 1));
      },
    }
  };
</script>

<style scoped>
  .brochure-modal {
    background: var(--p4surface5, #0F0F0F);
    padding: 20px;
  }
</style>